module.exports = __webpack_public_path__ + "static/media/img2.cc3895f6.jpeg";